/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LedgerOwnerType = {
    CHALLENGE: 'CHALLENGE',
    CAMPAIGN: 'CAMPAIGN',
    ACTIVATION: 'ACTIVATION',
    PLATFORM: 'PLATFORM',
    PARTNER: 'PARTNER',
    DROP: 'DROP',
    BRAND: 'BRAND'
} as const;
export type LedgerOwnerType = typeof LedgerOwnerType[keyof typeof LedgerOwnerType];


export function instanceOfLedgerOwnerType(value: any): boolean {
    for (const key in LedgerOwnerType) {
        if (Object.prototype.hasOwnProperty.call(LedgerOwnerType, key)) {
            if (LedgerOwnerType[key as keyof typeof LedgerOwnerType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LedgerOwnerTypeFromJSON(json: any): LedgerOwnerType {
    return LedgerOwnerTypeFromJSONTyped(json, false);
}

export function LedgerOwnerTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): LedgerOwnerType {
    return json as LedgerOwnerType;
}

export function LedgerOwnerTypeToJSON(value?: LedgerOwnerType | null): any {
    return value as any;
}

export function LedgerOwnerTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): LedgerOwnerType {
    return value as LedgerOwnerType;
}

